import React from "react";
import { CmsService } from "../services";
import $ from "jquery";

export default class BaseComponent extends React.Component {
  constructor(props) {
    super(props);
    this.cmsPageAlias = null;
  }

  get cmsContent() {
    return this.cmsPageAlias &&
      CmsService.content &&
      CmsService.content.pages[this.cmsPageAlias]
      ? CmsService.content.pages[this.cmsPageAlias]
      : null;
  }

  formToJson(form) {
    const inputs = $(form).serializeArray();
    const result = {};
    inputs.forEach((n) => {
      result[n.name] = n.value;
    });
    return result;
  }

  deserializeForm(form) {
    return this.formToJson(form);
  }

  label(key) {
    var retVal = "";
    try {
      retVal = CmsService.content.labels[key.toLowerCase()] || key;
    } catch (e) {
      return key;
    }
    return retVal;
  }

  siteSetting(key) {
    var retVal = "";
    try {
      retVal = CmsService.content.pages.sitesettings[key] || key;
    } catch (e) {
      return key;
    }
    return retVal;
  }

  /**
   * Boolean site setting. siteSetting above returns the key name when a value is missing, which
   * makes every flag read truthy; this one treats missing, empty or unloaded as false.
   */
  siteSettingBool(key) {
    try {
      const value = CmsService.content.pages.sitesettings[key];

      return String(value).trim().toLowerCase() === "true";
    } catch (e) {
      return false;
    }
  }

  /**
   * Whether a form type is marked for display in the forms lobby.
   *
   * The lobby (yelin.forms.client) shows a form only when its Umbraco isshowinlobby property is
   * "true", and the shortcut areas here link to the same forms, so they have to honour the same
   * per-form switch. Aliases look like "personal_1" / "digital-deposit_21", so the form type is
   * the segment after the underscore.
   *
   * If the list itself is unavailable this returns true: with nothing to consult, leaving the
   * shortcuts alone is far better than emptying the whole area.
   */
  isFormShownInLobby(formTypeId) {
    let list;
    try {
      list = CmsService.content.pages.forms.list;
    } catch (e) {
      list = null;
    }

    if (!Array.isArray(list) || !list.length) return true;

    const form = list.find(
      (item) => item && String(item.alias).split("_")[1] === String(formTypeId)
    );

    // Strict "true", exactly as the lobby compares it. A looser read here could surface a form
    // in the shortcuts that the lobby itself hides.
    return String(form && form.isshowinlobby) === "true";
  }

  getYearsArray(comp) {
    var syb =  this.siteSetting('numberyearstoshow')
    if (syb === null) {
      if (comp === "SYBS") syb = "3";
      if (comp === "SYBT") syb = "3";
      if (comp === "SYBR") syb = "11";
    }

    var maxRevaluationDate = sessionStorage.getItem("maxRevaluationDate");
    var years = [];
    for (let i = 0; i < parseInt(syb); i++) {
      years.push(parseInt(maxRevaluationDate) - i);
    }
    return years;
  }
}
